<template>
  <article>
    <group v-if="appointment.id">
      <x-input
        title="服务项目"
        :required=true
        placeholder="请选择服务项目"
        :readonly=true
        @click.native="onShowServices"
        :value="serviceName"
        @on-vali="afterValidate"
        is-link
      ></x-input>
      <x-input
        title="预约分配"
        :required="true"
        placeholder="请选择预约分配"
        :readonly="true"
        @click.native="showTimeSelectPopup = true"
        :value="currentSelected.value"
        @on-vali="afterValidate"
        is-link
      ></x-input>
    </group>
    <group :gutter="mt10">
      <x-input
        title="车牌号码"
        :is-type="validatePlateNumber"
        placeholder="粤A12345"
        v-model="appointment.plate_number"
        @on-vali="afterValidate"
        :readonly="true"
        @click.native="showPlateNumberPopup = true"
        is-link
      ></x-input>
      <x-input
        title='车架号码'
        @on-vali="afterValidate"
        :is-type="validateVin"
        :max="17"
        placeholder="车架号码"
        :readonly="true"
        @click.native="showVinPopup = true"
        v-model="appointment.vin"
        is-link
      ></x-input>
      <x-input
        title="车型"
        :max="30"
        placeholder="车型"
        v-model.trim="appointment.car_model"
      ></x-input>
      <x-input
        title="来源渠道"
        :required="true"
        placeholder="请选择来源渠道"
        :readonly="true"
        @click.native="onShowChannel"
        v-model="appointment.channel.name"
        @on-vali="afterValidate"
        is-link
      ></x-input>
      <x-input title="当前里程" @on-vali="afterValidate" :is-type="validateMileage" placeholder="请输入公里数" v-model.number="appointment.mileage">
        <span slot="right">公里</span>
      </x-input>
    </group>
    <group :gutter="mt10">
      <x-input
        title="联系人"
        @on-vali="afterValidate"
        :is-type="validateName"
        placeholder="您的姓名"
        v-model="appointment.contact_name"
      ></x-input>
      <x-input
        title='手机号码'
        type="tel"
        @on-vali="afterValidate"
        :is-type="validateMobile"
        :max="11" placeholder="手机号码"
        v-model="appointment.contact_number"
        :readonly="true"
        @click.native="showContactNumberPopup = true"
        is-link
      ></x-input>
    </group>
    <group>
      <x-input
        title="其他标识"
        :max="30"
        placeholder="（选填）如发动机号"
        v-model="appointment.other_mark"
      ></x-input>
    </group>
    <group title="备注文字（选填）">
      <x-textarea :max="200" v-model="appointment.remark" placeholder="请输入100字以内的车辆情况描述" :show-counter="false"></x-textarea>
    </group>
    <group title="跟进人">
      <x-input
        title="跟进人"
        :required="true"
        :readonly="true"
        @on-vali="afterValidate"
        v-model="appointment.service_consultant.name"
        @click.native="onShowAdvisor"
        is-link
      >
        <img class="adviser-img" slot="label" :src="appointment.service_consultant.avatar" v-if="appointment.service_consultant.avatar">
        <img slot="label" class="adviser-img" src="../../stylesheets/images/avatar-pic.png" v-else>
        <span slot="right">更换跟进人</span>
      </x-input>
    </group>
    <section class="appointment-btn-bottom">
      <x-button @click.native="onSubmit" class="appointment-btn-fix" :class="{active: !error}" :type="'primary'">
        <div>
          提交预约
        </div>
      </x-button>
    </section>
    <!-- 服务项目弹层 -->
    <popup v-model="showServicePopup" style="height: 100%;overflow: auto;">
      <group title="服务项目">
        <checklist
          v-model="appointment.service_ids"
          label-position="left"
          :options="services"
          @on-change="handleServicesChange"
        />
      </group>
      <x-button @click.native="handleCloseService">确定</x-button>
    </popup>
    <!-- 车牌弹层 -->
    <PlateNumberOrVinPopup
      placeholder="请输入车牌号码"
      :isShowPopup="showPlateNumberPopup"
      :searchVal="appointment.plate_number"
      :valMaxLen="7"
      :queryType="2"
      @on-item="(item) => handleSelectPlateNumberOrVin(item, 'showPlateNumberPopup')"
      @on-confirm="(val) => handleConfirmPlateNumberOrVin(val, 'plate_number', 'showPlateNumberPopup')"
    />
    <!-- 车架号弹层 -->
    <PlateNumberOrVinPopup
      placeholder="请输入车架号"
      :isShowPopup="showVinPopup"
      :searchVal="appointment.vin"
      :valMaxLen="17"
      :queryType="3"
      @on-item="(item) => handleSelectPlateNumberOrVin(item, 'showVinPopup')"
      @on-confirm="(val) => handleConfirmPlateNumberOrVin(val, 'vin', 'showVinPopup')"
    />
    <!-- 手机号弹层 -->
    <popup v-model="showContactNumberPopup" style="height: 100%;overflow: auto;background: #fff;">
      <div class="search-header">
        <input class="search-header__input" @input="handleContactNumberInput" v-model="appointment.contact_number" placeholder="请输入手机号码" type="text">
        <button class="search-header__button" @click="handleConfirmContactNumber">确认</button>
      </div>
      <div class="appointment_items">
        <div v-for="(item, index) in contactNumberList" :key="index">
          <div class="select-down__item" @click="handleSelectContactNumber(item)">
            <span class="select-down__name">{{ item.contact_name || '--' }}</span>
            <span class="select-down__number">{{ item.contact_number || '--' }}</span>
            <span class="select-down__plate">{{ item.plate_number || '--' }}</span>
          </div>
        </div>
      </div>
    </popup>
    <!-- 来源渠道弹层 -->
    <popup v-model="showChannelPopup" style="height: 100%;overflow: auto;">
      <group title="来源渠道">
        <checker v-model="appointment.channel_id">
          <checker-item
            class="appointment-item"
            v-for="item in channels"
            :key="item.id"
            :value="item.id"
            @on-item-click="onSelectChannel"
          >
            <cell class="appointment-adviser">
              <!--<img slot="icon" class="appointment-adviser-img" :src="item.logo_url"></img>-->
              <span slot="after-title" class="appointment-title">{{item.name}}</span>
              <icon type="success_no_circle" v-if="item.id === appointment.channel_id"></icon>
            </cell>
          </checker-item>
        </checker>
      </group>
    </popup>
    <!-- 接待人弹层 -->
    <popup v-model="showAdvisorPopup" style="height: 100%;overflow: auto;">
      <group title="接待人">
        <checker v-model="appointment.service_consultant.id">
          <checker-item
            class="appointment-item"
            v-for="item in advisors"
            :key="item.id"
            :value="item.id"
            @on-item-click="onSelectAdvisor"
          >
            <cell class="appointment-adviser">
              <img slot="icon" class="adviser-img" :src="item.avatar" />
              <span slot="after-title" class="appointment-title">{{item.name}}</span>
              <icon type="success_no_circle" v-if="appointment.service_consultant.id === item.id"></icon>
            </cell>
          </checker-item>
        </checker>
      </group>
    </popup>
    <TimeSettingPopup
      v-model="showTimeSelectPopup"
      :appointed-time-type="appointedTimeType"
      :service-booking-id="serviceBookingId"
      :selectedInfo="currentSelected"
      :cb="timeSettingCb"
    ></TimeSettingPopup>
  </article>
</template>

<script>
import {
  Group,
  Cell,
  XInput,
  XTextarea,
  Checker,
  CheckerItem,
  Checklist,
  XButton,
  Popup,
  Icon
  // XDialog
} from '@lx-frontend/cvux'
import TimeSettingPopup from './TimeSettingPopup'
import PlateNumberOrVinPopup from './PlateNumberOrVinPopup'
import util from '../../common/util'

export default {
  components: {
    Group,
    Cell,
    XInput,
    XTextarea,
    Checker,
    CheckerItem,
    Checklist,
    XButton,
    Popup,
    Icon,
    TimeSettingPopup,
    PlateNumberOrVinPopup
  },
  data() {
    return {
      mt10: '0.13333333rem',
      timeError: false,
      serviceName: '',
      appointment: {
        channel: {},
        channel_id: '',
        service: {
          name: ''
        }, // 服务类型
        receiver: {
          name: ''
        }, // 接待人
        appointed_time: '', // 预计到店
        plate_number: '', // 车牌号码
        vin: '', // 车架号
        car_model: '', // 车型
        mileage: '', // 当前里程
        contact_name: '', // 联系人
        contact_number: '', // 手机号码
        other_mark: '', // 其他标识
        remark: '', // 备注
        service_consultant: { // 服务顾问
          name: ''
        }
      },
      fields: ['service_ids', 'appointed_time', 'plate_number', 'vin', 'mileage', 'contact_name', 'contact_number', 'other_mark', 'remark', 'receiver_id', 'car_model'],
      form: {
        id: '',
        service_ids: [], // 服务类型id
        receiver_id: 0, // 服务顾问id
        channel_id: 0, // 来源渠道id
        appointed_time: '', // 预计到店
        plate_number: '', // 车牌号码
        vin: '', // 车架号
        car_model: '', // 车型
        mileage: '', // 当前里程
        contact_name: '', // 联系人
        contact_number: '', // 手机号码
        other_mark: '', // 其他标识
        remark: '', // 备注
        service_consultant_id: 0 // 接待人id
      },
      validStatus: {}, // 表单校验状态
      showAdvisorPopup: false, // 顾问类别
      showServicePopup: false, // 服务类别
      // showDialog: false, // 展示成功对话框
      error: null, // 校验结果
      services: [], // 服务类别列表
      channels: [], // 来源渠道列表
      advisors: [], // 服务顾问列表
      isClicked: false,
      showTimeSelectPopup: false,
      showChannelPopup: false,
      showPlateNumberPopup: false, // 车牌
      showVinPopup: false, // 车架号
      showContactNumberPopup: false, // 手机号
      timer: null,
      contactNumberList: [],
      plateNumberList: [],
      vinList: [],
      defaultServices: {},
      isSetDefaultServiceId: false,
      serviceBookingId: '',
      // 1=可以修改今天、2、3=不可以修改、4=可以跨天修改
      appointedTimeType: 4,
      currentSelected: {
        date: '',
        time: '',
        consultant_id: -1,
        consultant_display: '',
        value: ''
      }
    }
  },
  async created() {
    const { id } = this.$route.params
    this.serviceBookingId = id
    this.$rest.appointment.getAppointmentDetailById(null, id).then((res) => {
      if (res.code === 0) {
        // 服务顾问
        const { id: receiverId, name: receiverName } = res.data.receiver || { id: -1, name: '' }
        const [date, time] = res.data.appointed_time.split(' ')
        this.defaultServices = JSON.parse(JSON.stringify(res.data))
        // 控制是否允许更改预约时间
        this.appointedTimeType = res.data.modify_appointed_time_type
        this.appointment = res.data
        this.appointment.channel_id = res.data.channel.id
        this.serviceName = res.data.services.map(item => item.name).join('、')
        this.appointment.receiver_id = receiverId
        this.appointment.receiver = { id: receiverId, name: receiverName }
        this.appointment.plate_number = res.data.plate_number
        this.appointment.vin = res.data.vin
        this.appointment.car_model = res.data.car_model
        this.appointment.service_consultant_id = res.data.service_consultant.id
        // fix-sentry: 如果后端没有给备注字段，就给 remark 一个空值
        this.appointment.remark = res.data.remark || ''
        this.appointment.service_ids = []
        this.form.channel_id = res.data.channel.id
        this.form.receiver_id = receiverId
        this.form.service_consultant_id = res.data.service_consultant.id
        this.currentSelected = {
          date,
          time,
          consultant_id: receiverId,
          consultant_display: receiverName,
          value: res.data.appointed_time + ' ' + receiverName
        }
      } else {
        this.showToast(res.message)
      }
    })
  },
  onUnload() {
    clearTimeout(this.timer)
  },
  methods: {
    validateDate(value) {
      if (value) {
        this.timeError = true
        this.showToast('预约时间必填')
      } else {
        this.timeError = false
      }
    },
    validatePlateNumber(val) {
      let valid = util.regexpMap.car_plate_number.test(val)
      return this.validate(val, valid, '请输入有效的车牌号，如\'粤B12345\'')
    },
    validateVin(val) {
      let valid = util.regexpMap.regexp_car_vin.test(val)
      return this.validate(val, valid, '请输入有效的车架号')
    },
    validateMileage(val) {
      let valid = util.regexpMap.regexp_car_mileage.test(val)
      return this.validate(val, valid, '请输入有效的里程')
    },
    validateName(val) {
      let valid = util.regexpMap.regexp_name_cn.test(val) || util.regexpMap.regexp_name_en.test(val)
      return this.validate(val, valid, '请输入有效的联系人名字')
    },
    validateMobile(val) {
      let valid = util.regexpMap.regexp_mobile.test(val)
      return this.validate(val, valid, '请输入有效的电话号码')
    },
    validate(val, valid, msg) {
      let validStatus = {}
      if (valid) {
        validStatus.valid = true
        validStatus.msg = ''
      } else {
        validStatus.valid = false
        validStatus.msg = msg
      }
      return validStatus
    },
    // 校验不通过时展示提示信息
    afterValidate(errors, valid, uuid) {
      // 将校验信息放进hash map 中
      // let msg = errors.format || errors.required
      let msg = Object.values(errors).pop()
      let validStatus = this.validStatus
      validStatus[uuid] = validStatus.uuid || {}
      validStatus[uuid].valid = valid
      validStatus[uuid].msg = msg
      // 获取一个错误的表单项
      this.error = this.getError()
      // if (this.error && this.error.msg) {
      // this.showToast(this.error.msg)
      // }
    },
    onSelectChannel(id) {
      this.showChannelPopup = false
      // 服务展示
      this.appointment.channel = this.channels.find(val => id === val.id)
      // 设置表单值
      this.form.channel_id = id
    },
    handleServicesChange(ids) {
      const curIds = ids.map(id => +id)
      // 服务展示
      this.serviceName = this.services
        .filter(item => curIds.indexOf(+item.key) >= 0)
        .map(item => item.value).join('、')
      // 设置表单值
      this.appointment.service_ids = curIds
    },
    onShowServices() {
      if (this.services.length <= 0) {
        this.$rest.appointment.getServices().then((res) => {
          if (res.code === 0) {
            if (!this.isSetDefaultServiceId) {
              this.appointment.service_ids = this.defaultServices.service_ids
              this.isSetDefaultServiceId = true
            }
            this.services = res.data.services.map(v => ({
              key: v.id + '',
              value: v.name
            }))
            this.showServicePopup = true
          } else {
            this.showToast('系统繁忙，请稍候再试！！')
          }
        })
      } else {
        this.showServicePopup = true
      }
    },
    handleCloseService() {
      this.appointment.service_ids = this.appointment.service_ids.map(id => +id)
      this.serviceName = this.services
        .filter(item => this.appointment.service_ids.indexOf(+item.key) >= 0)
        .map(item => item.value).join('、')
      this.showServicePopup = false
    },
    // 开启来源渠道的弹窗
    onShowChannel() {
      if (this.channels.length <= 0) {
        this.$rest.appointment.getChannels().then((res) => {
          if (res.code === 0) {
            this.channels = res.data.channels
            this.showChannelPopup = true
          } else {
            this.showToast('系统繁忙，请稍候再试！！')
          }
        })
      } else {
        this.showChannelPopup = true
      }
    },
    // 选择接待人
    onSelectAdvisor(id) {
      this.showAdvisorPopup = false
      // 顾问展示
      this.appointment.service_consultant = this.advisors.find(val => {
        return id === val.id
      })
      // 设置表单
      this.form.service_consultant_id = id
    },
    // 打开顾问列表
    onShowAdvisor() {
      if (this.advisors.length <= 0) {
        this.$rest.appointment.getConsultants().then((res) => {
          if (res.code === 0) {
            // 展示弹层
            let advisors = res.data.service_consultants
            this.advisors = advisors
            this.showAdvisorPopup = true
            // this.$store.commit('updateAdvisors', advisors)
          } else {
            this.showToast('系统繁忙，请稍候再试！！')
          }
        })
      } else {
        this.showAdvisorPopup = true
      }
    },
    getError() {
      let validStatus = this.validStatus
      return Object.values(validStatus).find(v => {
        return !v.valid
      })
    },
    onSendWx() {
      this.$wechat.promise.then(wx => {
        window.WeixinJSBridge.call('closeWindow')
      }, wx => {
        console.log('微信JSSDK校验错误:', wx.res)
      })
    },
    timeSettingCb(item) {
      const { date, time, consultant_id } = item
      this.appointment.appointed_time = date + ' ' + time
      this.appointment.receiver_id = consultant_id
      this.currentSelected = { ...item }
      this.showTimeSelectPopup = false
    },
    onSubmit() {
      let error = this.getError()
      if (!error) {
        if (this.timeError) {
          this.showToast('预约时间必填')
        } else {
          this.fields.forEach(v => {
            if (this.appointment[v]) {
              this.form[v] = this.appointment[v]
            }
          })
          if (!this.isSetDefaultServiceId && this.appointment.service_ids.length === 0) {
            this.form.service_ids = this.defaultServices.service_ids
          }
          if (!(this.form.plate_number || this.form.vin)) {
            this.showToast('车牌号或车架号至少填写一项')
            return
          }
          // this.form.appointed_time = this.form.appointed_time.trim() + ':00'
          if (this.isClicked) {
            return false
          }
          this.isClicked = true
          // 数字类型的公里数为选填填，故而需要特殊处理一下
          if (!this.form.mileage) {
            delete this.form.mileage
          }
          if (!this.form.receiver_id || this.form.receiver_id === -1) delete this.form.receiver_id

          console.log(this.appointment, this.form)
          this.$rest.appointment.updateAppointment(this.$route.params.id)(this.form).then(res => {
            if (res.code === 0) {
              // this.showDialog = true
              // this.$router.push({
              //   path: '/appointment/success',
              //   query: {
              //     name: this.appointment.service_consultant.name,
              //     mobile_number: this.appointment.service_consultant.mobile_number
              //   }
              // })
              this.$router.go(-1)
              this.showToast(res.message)
            } else {
              this.showToast(res.message)
            }
            this.isClicked = false
          }, (res) => {
            this.isClicked = false
            this.showToast(res.message)
          })
        }
      } else {
        if (error.msg) {
          this.showToast(error.msg)
        }
      }
    },
    handleSelectContactNumber(item) {
      this.showContactNumberPopup = false
      const { contact_name: contactName, contact_number: contactNumber, plate_number: plateNumber } = item
      this.appointment.contact_name = contactName
      this.appointment.contact_number = contactNumber
      this.appointment.plate_number = plateNumber
    },
    handleSelectPlateNumberOrVin(item, showTypePopup) {
      this[showTypePopup] = false
      const { contact_name: contactName, contact_number: contactNumber, plate_number: plateNumber, vin, model_desc } = item
      this.appointment.contact_name = contactName
      this.appointment.contact_number = contactNumber
      this.appointment.plate_number = plateNumber
      this.appointment.vin = vin
      this.appointment.car_model = model_desc
    },
    handleConfirmPlateNumberOrVin(val, keyField, showTypePopup) {
      this.appointment[keyField] = val
      this[showTypePopup] = false
    },
    handleConfirmContactNumber() {
      this.showContactNumberPopup = false
    },
    async handleContactNumberInput() {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        const { code, data, message } = await this.$rest.appointment.getBookingRecord({ query_type: 1, query_text: this.appointment.contact_number })
        if (code !== 0) {
          this.showToast(message)
          return
        }
        this.contactNumberList = data
      }, 1000)
    }
  }
}
</script>

<style scoped lang="less">
@import "../../stylesheets/base/fn";
.adviser-img {
  display: block;
  width: 96/@w2;
  height: 96/@w2;
  border-radius: 50%;
}

.appointment-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.appointment-advisor-right {
  color: #b8b8b8;
}

.appointment-item {
  width: 100%;
}

.appointment-adviser-img {
  display: block;
  width: 60/@w2;
  height: 60/@w2;
}
.appointment-adviser:after {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 1px;
  border-top: 1px solid #D9D9D9;
  color: #D9D9D9;
  margin-left: 30/@w2;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.appointment-btn-bottom {
  position: relative;
  z-index: 10;
  padding-top: 58/@w;
  .appointment-btn-fix {
    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;
    font-size: 30/@w2;
    height: 96/@w2;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    display: -webkit-box;
    display: box;
    border-radius: 0px;
    color: #948d8d;
    background-color: #ccc;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    box-align: center;
    justify-content: center;
    align-items: center;
    &.active {
      background: #3b5999;
      color: #fff;
    }
  }
  .appointment-btn-fix:after{
    border-radius: 0px;
    border: none;
  }
}

.search-header{
  background-color: #eee;
  display: flex;
  justify-content: space-around;
  padding: 30/@w2 0;

  &__input{
    width: 75%;
    height: 80/@w2;
    line-height: 80/@w2;
    border: none;
    color: #948d8d;
    padding-left: 20/@w2;
    box-sizing: border-box;
  }

  &__button{
    width: 20%;
    height: 80/@w2;
    line-height: 80/@w2;
    background: #3b5999;
    color: #fff;
  }
}

.select-down{
  &__item{
    width: 100%;
    height: 100/@w2;
    line-height: 100/@w2;
    display: flex;
    justify-content: space-around;
    text-align: center;
    box-sizing: border-box;
    color: #948d8d;
    border-bottom: 1px solid #F2F2F2;
  }

  &__name{
    width: 140/@w2;
  }

  &__number{
    width: 200/@w2;
  }

  &__plate{
    width: 180/@w2;
  }
}
</style>
